import { type QueryClient, queryOptions, useQuery } from '@tanstack/react-query'
import { fetchUserProfile } from '@/features/account/services/User/fetchers'
import { useSession } from '@/features/authentication/utils/authentication/hooks/useSession'
import { userQueryOptions } from '@/features/account/services/User/queryOptions'

export const useQueryUser = ({ enabled = true } = {}) => {
  const { isFullyAuthenticated } = useSession()

  return useQuery({
    ...userQueryOptions,
    enabled: Boolean(isFullyAuthenticated && enabled),
  })
}

export const fetchUserQuery = (queryClient: QueryClient) => queryClient.query(userQueryOptions)

export const userProfileRootKey = 'UserProfile'

export type UserProfileQueryKey = readonly [typeof userProfileRootKey, number]

export const userProfileQueryOptions = (userId: number) =>
  queryOptions({
    queryKey: [userProfileRootKey, userId],
    queryFn: fetchUserProfile,
  })

export const useQueryUserProfile = () => {
  const { userId } = useSession()
  return useQuery({
    ...userProfileQueryOptions(userId),
    enabled: Boolean(userId),
  })
}
